import { render, staticRenderFns } from "./faqGroupsList.vue?vue&type=template&id=50327dbc&scoped=true&"
import script from "./faqGroupsList.vue?vue&type=script&lang=js&"
export * from "./faqGroupsList.vue?vue&type=script&lang=js&"
import style0 from "./faqGroupsList.vue?vue&type=style&index=0&id=50327dbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50327dbc",
  null
  
)

export default component.exports